module.exports = __webpack_public_path__ + "img/UTPIUT-5.cbcaabaa.jpg";